<template>
  <div :class="['login-page',appType === 'mobile'?'login-page-mb':'']">
    <img :src="pageBg" class="page-bg-img" alt="" />
    <div class="page-content">
      <div :class="['top-title',appType === 'mobile'?'top-title-mb':'']">
        <img v-if="schoolLogoImg" :src="schoolLogoImg" alt="" />
        <span :class="['top-name',appType === 'mobile'?'top-name-mb':'']">{{ pageTitle }}</span>
      </div>
      <div class="login-content">
        <div :class="['welcome-box',appType === 'mobile'?'welcome-box-mb':'']">
          <!-- <div class="left-welcome"></div> -->
        </div>
        <div :class="['login-way',appType === 'mobile'?'login-way-mb':'']">
          <img :class="['mobile-img',appType === 'mobile'?'mobile-img-mb':'']" :src="schoolLogoImg" alt="" />
          <div :class="['media-tips',appType === 'mobile'?'media-tips-mb':'']">
            <img
              class="icon-img"
              src="../../assets/img/web_icon.png"
              alt=""
            /><span class="way-tips">请选择您的登录方式</span>
          </div>
          <img
            :class="['mobile-icon',appType === 'mobile'?'mobile-icon-mb':'']"
            :src="mobileIcon"
            alt=""
          />
          <div :class="['login-name',appType === 'mobile'?'login-name-mb':'']">{{ pageTitle }}</div>
          <img :class="['primary-img',appType === 'mobile'?'primary-img-mb':'']" :src="primaryImg" alt="" @click="handlePrimaryLink"/>
          <img :class="['other-img',appType === 'mobile'?'other-img-mb':'']" :src="otherImg" alt=""  @click="handleOtherLink"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCustomList, getPageSetting, getlinkSetting
} from '../../api/login'
export default {
  name: 'login',
  data () {
    return {
      pageTitle: '',
      pcPageBg: '',
      mobilePageBg: '',
      PageBg: '',
      schoolLogoImg: '',
      // primaryImg: '',
      primaryPcImg: '',
      primaryMobileImg: '',
      primaryPcLink: '',
      primaryMobileLink: '',
      // primarylink: '',
      otherPcImg: '',
      otherMobileImg: '',
      // otherlink: '',
      otherPcLink: '',
      otherMobileLink: '',
      // otherImg: '',
      mobileIcon: '',
      appType: 'pc',
      localUrl: window.location.protocol + '//' + window.location.host
    }
  },
  created () {
    // 获取当前设备的屏宽来判断对应显示的设备（不通过navigator.userAgent）
    // let gotWidth = document.documentElement.clientWidth
    // if (gotWidth < 751) {
  // 获取屏幕宽度
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    var userAgentInfo = navigator.userAgent
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgentInfo)
    // var isTablet = /iPad|Android/i.test(userAgentInfo)
    // var isDesktop = !isMobile && !isTablet
    console.log(userAgentInfo, '当前设备信息', isMobile)
    if (isMobile && screenWidth < 768) {
      this.appType = 'mobile'
    } else {
      // 其他都归类于pc
      this.appType = 'pc'
    }
    // 获取当前域名并知悉当前的sign标识便是租户的信息
    this.queryCustomCode()
  },
  methods: {
    queryCustomCode () {
      let data = {}
      data.limit = 1000
      data.page = 1
      getCustomList(data).then((res) => {
        if (res.status === 200) {
          let allList = res.data.list
          if (allList.length > 0) {
            let currentHost = document.domain
            // let currentHost = 'ad.ad'
            let findItem = allList.find((item) => {
              // 暂时不用管ip与域名之间的转化，让用户自己去协调一致
              return item.domainOrIp === currentHost
            })
            if (findItem) {
              this.tenantSign = findItem.sign
              // 获取tenantCode再去获取页面
              if (this.tenantSign) {
                this.gotPageSet()
                this.linkSet()
              }
            }
          }
        } else {
          // 设置默认背景图
          console.log(res.message)
        }
      })
    },
    gotPageSet () {
      let data = {}
      if (this.tenantSign) {
        data.tenantCode = this.tenantSign
      } else {
        return false
      }
      getPageSetting(data).then(res => {
        if (res.status === 200) {
          let gotData = res.data
          if (gotData.length > 0) {
            gotData.map(item => {
              switch (item.sypaCode) {
                case 'StuLogo':
                  this.schoolLogoImg = item.sypaValue ? this.localUrl + item.sypaValue : ''
                  break
                case 'PcBackPic':
                  this.pcPageBg = item.sypaValue ? this.localUrl + item.sypaValue : require('../../../static/img/bg-default-pc.png')
                  break
                case 'MoBackPic':
                  this.mobilePageBg = item.sypaValue ? this.localUrl + item.sypaValue : require('../../../static/img/bg-default-mobile.png')
                  break
                case 'MobileIcon':
                  this.mobileIcon = item.sypaValue ? this.localUrl + item.sypaValue : require('../../../static/img/mobile_title.png')
                  break
              }
            })
          }
        }
      })
    },
    linkSet () {
      let data = {}
      if (this.tenantSign) {
        data.tenantCode = this.tenantSign
        data.applyId = 'jy-application-login'
        data.keyList = ['PlatformName', 'LoginJump', 'UnLoginJump']
      } else {
        return false
      }
      getlinkSetting(data).then(res => {
        if (res.status === 200) {
          let gotData = res.data
          this.pageTitle = gotData.platformName.name ? gotData.platformName.name : '资源云服务平台'
          this.primaryPcImg = gotData.loginJump.webPicUrl ? this.localUrl + gotData.loginJump.webPicUrl : require('../../../static/img/primary-pc.png')
          this.primaryPcLink = gotData.loginJump.webUrl
          this.primaryMobileImg = gotData.loginJump.mobilePicUrl ? this.localUrl + gotData.loginJump.mobilePicUrl : require('../../../static/img/primary-mobile.png')
          this.primaryMobileLink = gotData.loginJump.mobileUrl
          this.otherPcImg = gotData.unLoginJump.webPicUrl ? this.localUrl + gotData.unLoginJump.webPicUrl : require('../../../static/img/other-pc.png')
          this.otherPcLink = gotData.unLoginJump.webUrl
          this.otherMobileImg = gotData.unLoginJump.mobilePicUrl ? this.localUrl + gotData.unLoginJump.mobilePicUrl : require('../../../static/img/other-mobile.png')
          this.otherMobileLink = gotData.unLoginJump.mobileUrl
        }
      })
    },
    handlePrimaryLink () {
      window.open(this.primarylink)
    },
    handleOtherLink () {
      window.open(this.otherlink)
    }
  },
  computed: {
    pageBg () {
      if (this.appType === 'mobile') {
        return this.mobilePageBg
      } else {
        return this.pcPageBg
      }
    },
    // eslint-disable-next-line vue/no-dupe-keys
    primaryImg () {
      if (this.appType === 'mobile') {
        return this.primaryMobileImg
      } else {
        return this.primaryPcImg
      }
    },
    // eslint-disable-next-line vue/no-dupe-keys
    otherImg () {
      if (this.appType === 'mobile') {
        return this.otherMobileImg
      } else {
        return this.otherPcImg
      }
    },
    // eslint-disable-next-line vue/no-dupe-keys
    primarylink () {
      if (this.appType === 'mobile') {
        return this.primaryMobileLink
      } else {
        return this.primaryPcLink
      }
    },
    // eslint-disable-next-line vue/no-dupe-keys
    otherlink () {
      if (this.appType === 'mobile') {
        return this.otherMobileLink
      } else {
        return this.otherPcLink
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-page {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 56px;
  position: relative;
  display: flex;
  flex-direction: column;
  .page-bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 0;
  }
  .page-content{
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .top-title {
    position: absolute;
    width: 100%;
    height: 4.5rem;
    display: flex;
    align-content: center;
    justify-content: flex-start;
    .top-name {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      color: #2252A2;
      font-weight: 600;
      line-height: 45px;
      margin-left: 43px;
    }
    img {
      width: 309px;
      height: 72px;
    }
  }
  .mobile-img {
    display: none;
  }
  .login-content {
    flex: 1;
    width: 100%;
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    .welcome-box {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .login-way {
      width: 396px;
      height: 389px;
      background: #fff;
      border-radius: 20px;
      padding: 50px;
      .media-tips {
        display: flex;
        align-items: center;
        .icon-img {
          width: 30px;
          height: 30px;
        }
        .way-tips {
          margin-left: 10px;
          font-family: PingFangSC-Semibold;
          font-size: 32px;
          color: #333333;
          font-weight: 600;
        }
      }
      .mobile-icon {
        display: none;
      }
      .primary-img {
        margin-top: 26px;
        width: 396px;
        height: 173px;
        cursor: pointer;
      }
      .other-img {
        cursor: pointer;
        margin-top: 30px;
        width: 396px;
        height: 116px;
      }
    }
    .login-name {
      display: none;
    }
  }
}
// //在页面放大150时的屏宽是1308 不能超过这个尺寸
// @media screen and (min-width:750px) and (max-width:1300px) {
//    .mobile-img {
//     display: block !important;
//     position: absolute;
//     top: -13.28vh;
//     left: 4.26vw;
//     width: 64.5vw !important;
//     height: 14.9vw !important;
//   }
//   .login-page {
//     padding: 7.46vw !important;
//   }
//   .top-title {
//     display: none !important;
//   }

//   .top-name {
//     display: none;
//   }
//   .welcome-box {
//     display: none !important;
//   }
//   .login-way {
//     width: 94.26vw !important;
//     height: 60.84vh !important;
//     padding: 4.26vw !important;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     position: relative;
//   }
//   .media-tips {
//     display: none !important;
//   }
//   .mobile-icon {
//     display: block !important;
//     margin-top: 4.92vh;
//     width: 24vw !important;
//     height: 24vw !important;
//   }
//   .login-name {
//     display: block !important;
//     font-family: PingFangSC-Semibold;
//     font-size: 6.13vw;
//     color: #333333;
//     letter-spacing: 0;
//     text-align: center;
//     font-weight: 600;
//     margin-top: 6.4vw;
//   }
//   .primary-img {
//     margin-top: 11.46vw !important;
//     width: 85.06vw !important;
//     height: 4.92vh !important;
//   }
//   .other-img {
//     margin-top: 2.95vh !important;
//     width: 85.06vw !important;
//     height: 4.92vh !important;
//   }
// }

// 移动端（<750px）
  .mobile-img-mb {
    display: block !important;
    position: absolute;
    top: -10.28vh;
    left: 4.26vw;
    width: 64.5vw !important;
    height: 14.9vw !important;
  }
  .login-page-mb {
    padding: 7.46vw !important;
  }
  .top-title-mb {
    display: none !important;
  }

  .top-name-mb {
    display: none;
  }
  .welcome-box-mb {
    display: none !important;
  }
  .login-way-mb {
    width: 94.26vw !important;
    height: 47.84vh !important;
    padding: 4.26vw !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .media-tips-mb {
    display: none !important;
  }
  .mobile-icon-mb {
    display: block !important;
    margin-top: 4.92vh;
    width: 24vw !important;
    height: 24vw !important;
  }
  .login-name-mb {
    display: block !important;
    font-family: PingFangSC-Semibold;
    font-size: 6.13vw;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
    margin-top: 6.4vw;
  }
  .primary-img-mb {
    margin-top: 11.46vw !important;
    width: 85.06vw !important;
    height: 4.92vh !important;
  }
  .other-img-mb {
    margin-top: 2.95vh !important;
    width: 85.06vw !important;
    height: 4.92vh !important;
  }
</style>
